<div class="admin-page">
  <header class="admin-header">
    <div class="header-inner">
      <div class="heading">
        <a routerLink="/concurso-fotografias" class="back" aria-label="Voltar à votação"><span class="material-symbols-outlined">arrow_back</span></a>
        <img src="assets/ecodados-symbol.svg" alt="EcoDados">
        <div><p>Concurso de fotografias</p><h1>Administração</h1></div>
      </div>
      <p-button label="Nova fotografia" icon="pi pi-plus" severity="secondary" [rounded]="true" (onClick)="abrirCadastro()" />
    </div>
  </header>

  <main class="admin-main">
    <section class="metrics">
      <div><span class="material-symbols-outlined">photo_library</span><p>Fotografias<strong>{{ fotos().length }}</strong></p></div>
      <div><span class="material-symbols-outlined">how_to_vote</span><p>Participantes<strong>{{ totalVotos() }}</strong></p></div>
      <div><span class="material-symbols-outlined">visibility</span><p>Ativas<strong>{{ fotos().filter(f => f.ativa).length }}</strong></p></div>
    </section>

    <section class="admin-controls">
      <label>Ordenar fotografias
        <select [value]="ordem()" (change)="alterarOrdem($any($event.target).value)">
          <option value="ALFABETICA">Ordem alfabética</option>
          <option value="VOTOS">Mais votadas</option>
        </select>
      </label>
      <label class="podium-toggle"><p-toggleswitch [ngModel]="votacaoAberta()" (ngModelChange)="alterarVotacao($event)" /> Votação ativa</label>
      <label class="podium-toggle"><p-toggleswitch [ngModel]="podioLiberado()" (ngModelChange)="alterarPodio($event)" /> Liberar pódio para o público</label>
    </section>

    @if (erro()) { <div class="message error"><span class="material-symbols-outlined">error</span>{{ erro() }}<button (click)="erro.set('')">×</button></div> }
    @if (sucesso()) { <div class="message success"><span class="material-symbols-outlined">check_circle</span>{{ sucesso() }}<button (click)="sucesso.set('')">×</button></div> }

    @if (carregando()) {
      <div class="loading">Carregando fotografias...</div>
    } @else {
      <section class="admin-grid">
        @for (foto of fotos(); track foto.id) {
          <article class="admin-card" [class.inactive]="!foto.ativa">
            <img [src]="foto.imagemUrl" [alt]="foto.titulo">
            <div class="card-body">
              <div class="title-row"><h2>{{ foto.titulo }}</h2><span class="votes">{{ foto.votos }} {{ foto.votos === 1 ? 'voto' : 'votos' }}</span></div>
              <p>{{ foto.descricao }}</p>
              <div class="status-row">
                <label><p-toggleswitch [ngModel]="foto.ativa" (ngModelChange)="alterarStatus(foto, $event)" /> {{ foto.ativa ? 'Ativa' : 'Inativa' }}</label>
                <div class="actions">
                  <p-button icon="pi pi-pencil" severity="secondary" [text]="true" [rounded]="true" ariaLabel="Editar" (onClick)="abrirEdicao(foto)" />
                  <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" ariaLabel="Excluir" [disabled]="foto.votos > 0" (onClick)="excluir(foto)" />
                </div>
              </div>
            </div>
          </article>
        } @empty { <div class="empty"><span class="material-symbols-outlined">add_photo_alternate</span><h2>Nenhuma fotografia cadastrada</h2><p>Adicione a primeira concorrente para iniciar a exposição.</p></div> }
      </section>
    }
  </main>

  <p-dialog header="Nova fotografia" [visible]="modalCadastro()" [modal]="true" [style]="{ width: '94vw', maxWidth: '600px' }" [draggable]="false" (onHide)="modalCadastro.set(false)">
    <div class="form">
      <label>Título<input maxlength="150" [ngModel]="titulo()" (ngModelChange)="titulo.set($event)" placeholder="Título da fotografia"></label>
      <label>Descrição<textarea rows="4" maxlength="1000" [ngModel]="descricao()" (ngModelChange)="descricao.set($event)" placeholder="Conte a história desta imagem"></textarea></label>
      <label class="upload"><input type="file" accept="image/jpeg,image/png,image/webp" (change)="selecionarArquivo($event)">
        @if (preview()) { <img [src]="preview()" alt="Pré-visualização"> } @else { <span class="material-symbols-outlined">cloud_upload</span><strong>Selecionar fotografia</strong><small>JPEG, PNG ou WebP · até 10 MB</small> }
      </label>
      <div class="form-actions"><p-button label="Cancelar" severity="secondary" [outlined]="true" (onClick)="modalCadastro.set(false)" /><p-button label="Cadastrar" icon="pi pi-check" [loading]="salvando()" (onClick)="cadastrar()" /></div>
    </div>
  </p-dialog>

  <p-dialog header="Editar fotografia" [visible]="editando() !== null" [modal]="true" [style]="{ width: '94vw', maxWidth: '560px' }" [draggable]="false" (onHide)="editando.set(null)">
    @if (editando(); as foto) {
      <div class="form"><label>Título<input maxlength="150" [(ngModel)]="foto.titulo"></label><label>Descrição<textarea rows="5" maxlength="1000" [(ngModel)]="foto.descricao"></textarea></label>
        <div class="form-actions"><p-button label="Cancelar" severity="secondary" [outlined]="true" (onClick)="editando.set(null)" /><p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (onClick)="salvarEdicao()" /></div>
      </div>
    }
  </p-dialog>
</div>
